import { render, staticRenderFns } from "./reuters.vue?vue&type=template&id=a5ed3c74&"
import script from "./reuters.vue?vue&type=script&lang=js&"
export * from "./reuters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports